import * as React from 'react'
import { Flex } from 'components/ds'
type Props = {
  children: React.ReactNode
  className?: string
  vertical?: boolean
  centered?: boolean
  compact?: boolean
  alignRight?: boolean
  // To support legacy code
  paddingTop?: boolean
}

// takes care of spacing between buttons, so you don't have to
/**
 * A container component that handles spacing and alignment of buttons
 *
 * @param children - Button elements to be contained
 * @param className - Additional CSS class name
 * @param vertical - Whether to arrange buttons vertically
 * @param centered - Whether to center the buttons
 * @param compact - Whether to use compact spacing
 * @param alignRight - Whether to align buttons to the right
 * @param paddingTop - Whether to add top padding (legacy support)
 * @returns The button container component
 */
const ButtonContainer = ({
  children,
  className,
  vertical,
  centered,
  compact,
  alignRight,
  paddingTop,
}: Props): React.ReactElement<'div'> => (
  <Flex
    gap={compact ? '1' : '2'}
    align={vertical ? undefined : 'center'}
    justify={centered ? 'center' : alignRight ? 'end' : 'start'}
    direction={vertical ? 'column' : 'row'}
    pt={paddingTop ? '2' : '0'}
    className={className}
  >
    {children}
  </Flex>
)

export default ButtonContainer
